export default "__VITE_ASSET__Bpq3XTew__"